import { ContentStyle } from '../../../types/ContentStyle';
import { veeqoErrors } from './errors/veeqo';
import { seCeErrors } from './errors/seCe';

export const errors = {
  [ContentStyle.SELLER_CENTRAL]: seCeErrors,
  [ContentStyle.VEEQO]: veeqoErrors,
};

export const ErrorTypes = {
  DEFAULT: 'DEFAULT',
  EMAIL_ALREADY_IN_USE: 'EMAIL_ALREADY_IN_USE',
  INSUFFICIENT_PERMISSIONS: 'INSUFFICIENT_PERMISSIONS',
  STORE_CONNECTION_ERROR: 'STORE_CONNECTION_ERROR',
  STORE_ALREADY_IN_USE: 'STORE_ALREADY_IN_USE',
  MISSING_MERCHANT_ADDRESS: 'MISSING_MERCHANT_ADDRESS',
  MISSING_MERCHANT_NAME: 'MISSING_MERCHANT_NAME',
  OWNER_STILL_ONBOARDING: 'OWNER_STILL_ONBOARDING',
  ACCOUNT_ALREADY_LINKED: 'ACCOUNT_ALREADY_LINKED',
  INVALID_INPUT: 'INVALID_INPUT',
  INTERNAL_ERROR: 'INTERNAL_ERROR',
  MULTIPLE_STORE_COLLECTION: 'MULTIPLE_STORE_COLLECTION',
} as const;

export type ErrorType = (typeof ErrorTypes)[keyof typeof ErrorTypes];
